import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const ease = [0.16, 1, 0.3, 1];

export default function Process() {
  const { t } = useLang();

  return (
    <section
      id="process"
      data-testid="process-section"
      className="py-24 md:py-36 bg-[#EFEFEF]"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease }}
          className="flex items-center gap-3 mb-12"
        >
          <span className="w-8 h-px bg-[#0A0A0A]" />
          <span className="font-mono text-[10px] md:text-xs tracking-[0.3em] uppercase">
            {t.process.overline} / 04
          </span>
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease }}
          className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight font-medium leading-[1.02] max-w-[22ch] mb-20"
        >
          {t.process.title}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-[#0A0A0A]/10">
          {t.process.steps.map((step, i) => (
            <motion.div
              key={step.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease, delay: i * 0.12 }}
              className="bg-[#EFEFEF] p-8 md:p-10 group hover:bg-[#F7F7F9] transition-colors duration-500"
            >
              <div className="flex items-center justify-between mb-10">
                <span className="font-mono text-xs tracking-[0.2em] text-[#5C5C5C]">{step.n}</span>
                <span className="w-8 h-8 rounded-full border border-[#0A0A0A]/30 flex items-center justify-center text-[10px] font-mono group-hover:bg-[#D35400] group-hover:border-[#D35400] group-hover:text-[#F7F7F9] transition-colors duration-500">
                  {i + 1}
                </span>
              </div>
              <h3 className="font-display text-xl md:text-2xl tracking-tight font-medium leading-tight mb-4">
                {step.t}
              </h3>
              <p className="text-sm md:text-base font-light leading-relaxed text-[#5C5C5C]">
                {step.d}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
